var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog-scroll-lock', {
    attrs: {
      "width": "300",
      "value": _vm.value
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "float-right ma-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', [_vm._v("Add to calendar")]), _c('v-card-subtitle', {
    staticClass: "pb-0"
  }, [_vm.isValid ? [_vm._v("Select your calendar service")] : _c('span', {
    staticClass: "warning--text"
  }, [_vm._v("Event details are incomplete")])], 2), _c('v-list', {
    staticClass: "text-body-2 primary--text"
  }, [_vm._l(_vm.vendors, function (_ref) {
    var img = _ref.img,
      name = _ref.name,
      click = _ref.click;
    return _c('v-list-item', {
      key: name,
      staticClass: "px-6 simple",
      attrs: {
        "disabled": !_vm.isValid
      },
      on: {
        "click": click
      }
    }, [_c('img', {
      attrs: {
        "width": "24",
        "height": "24",
        "src": img
      }
    }), _c('div', [_vm._v(_vm._s(name))])]);
  }), _c('v-divider', {
    staticClass: "my-2"
  }), _c('v-list-item', {
    staticClass: "px-6 simple",
    attrs: {
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.download
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiFileDownload)
    }
  }), _c('div', [_c('div', [_vm._v("Other")]), _c('div', {
    staticClass: "text--label-active"
  }, [_vm._v("Download calendar file")])])], 1)], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }